import {fetchQurasoftApi} from "api";
import {handleResponse} from "helpers/Requests";
import {deserializeStartContent, StartContent} from "../../../models/Login";

const fetchStartContent = (tenantName: string) => {
  const sorting = 'sort=createdAt:desc&pagination[limit]=1';

  return fetchQurasoftApi(
    `/saniq-start-contents?filters[platform][$eq]=web&filters[tenant][$eq]=${tenantName}&populate=media&populate=loginFormIcon&${sorting}`,
    'GET',
    {stopAfterNetworkError: true}
  )
    .then(handleResponse<StartContent>(deserializeStartContent, true));
};

export {fetchStartContent};
